import { FC } from "react";
import { Link, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import styles from "./styles.module.css";
import { truncateWords, isRTL } from "src/utils/global";
import { HomeProductItemType } from "src/types/products";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";

interface ProductProp {
    product?: HomeProductItemType;
}

const Product: FC<ProductProp> = ({ product }) => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();

    const productDetailHandle = () => {
        if (product?.slug) navigate(`/supplements/${product.slug}`);
    };

    // 🔸 Show skeleton when product is undefined
    if (!product) {
        return (
            <div className={`${styles.product} ${isRTL() && styles.rtl}`}>
                <div className={styles.card}>
                    <div className={`${styles.img__con} ${styles.skeleton__img}`}>
                        <Skeleton
                            className={styles.skeletonImg}
                            height={231}
                            width={308}
                            borderRadius={12}
                        />
                    </div>

                    <div className={`${styles.content} ${styles.skeleton__content}`}>
                        <h4 className={`${styles.title} ${styles.skeleton__title}`}>
                            <Skeleton
                                className={styles.skeletonTitle}
                                width={200}
                                height={24}
                            />
                        </h4>

                        <div className={styles.skeleton__icon}>
                            <Skeleton
                                className={styles.skeletonIcon}
                                circle
                                width={52}
                                height={52}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // 🔸 Show real content when product exists
    return (
        <div className={`${styles.product} ${isRTL() && styles.rtl}`}>
            <div className={styles.card}>
                <div className={styles.img__con}>
                    {!product ?
                        <Skeleton
                            className={styles.skeletonImg}
                        />
                        :

                        <>
                            <img
                                src={product.thumbnail}
                                alt={product.name}
                                loading="lazy"
                                width={308}
                                height={231}
                            />
                            <div className={styles.overlay} onClick={productDetailHandle}></div>
                        </>
                    }


                </div>
                <div className={styles.content}>
                    <h4 className={styles.title}>
                        <Link to={`/supplements/${product.slug}`}>
                            {truncateWords(product.name || "", 7)}
                        </Link>
                    </h4>
                    <Link className={styles.link} to={`/supplements/${product.slug}`}>
                        {i18n.language.includes("ar") ? (
                            <FaArrowLeft color="#fff" />
                        ) : (
                            <FaArrowRight color="#fff" />
                        )}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Product;
